<div class=regular-background>
    <img class="zoom-image" src="../../assets/ARTISTIC-REVOLUTION-Records-Logo.png">
</div>